import { render, staticRenderFns } from "./edicaoTabs.vue?vue&type=template&id=84ed7e98&scoped=true"
import script from "./edicaoTabs.vue?vue&type=script&lang=js"
export * from "./edicaoTabs.vue?vue&type=script&lang=js"
import style0 from "./edicaoTabs.vue?vue&type=style&index=0&id=84ed7e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ed7e98",
  null
  
)

export default component.exports